import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-article",
  "use": "icon-article-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-article\"><defs><style></style></defs><path d=\"M853.333 938.667H170.667A42.667 42.667 0 01128 896V128a42.667 42.667 0 0142.667-42.667h682.666A42.667 42.667 0 01896 128v768a42.667 42.667 0 01-42.667 42.667zM298.667 256v170.667h170.666V256H298.667zm0 256v85.333h426.666V512H298.667zm0 170.667V768h426.666v-85.333H298.667zm256-384V384h170.666v-85.333H554.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol